module.exports = __webpack_public_path__ + "img/hero-logo-bg.f98cc355.svg";